import {SignupRequest} from "../models/signup-request.model";
import {PageRequest} from "../models/page-request.model";
import {Cheque, ChequeRequest} from "../models/cheque.model";
import {ChequeCotizacionListFilter} from "../models/cotizacion-list-filter.model";
import {OfertaListFilter} from '../models/oferta.model';
import {ChequePortfolioFilter} from '../models/cheque-portfolio-filter.model';

export class GetChequeParametersAction {
  static readonly type = '[Cheque] GetChequeParametersAction';
}

export class GetChequePropioListAction {
  static readonly type = '[Cheque] GetChequePropioListAction';
  constructor(public payload: { filter: ChequePortfolioFilter }) {}
}
export class GetChequeParaInversionListAction {
  static readonly type = '[Cheque] GetChequeParaInversionListAction';
  constructor(public payload: { filter: ChequePortfolioFilter }) {}
}
export class GetChequeAction {
  static readonly type = '[Cheque] GetChequeAction';
  constructor(public payload: {cehqueId}) {}
}
export class DescontarChequeAction {
  static readonly type = '[Cheque] DescontarChequeAction';
  constructor(public payload:ChequeRequest) {}
}
export class RedescontarChequeAction { //"publicar" o "republicar" cheque
  static readonly type = '[Cheque] RedescontarChequeAction';
  constructor(public payload: { chequeId:any, montoEsperado:number }) {}
}

export class SearchChequeCotizacionListAction {
  static readonly type = "[Cheque] SearchChequeCotizacionList";
  constructor(public payload: { filter: ChequeCotizacionListFilter }) {}
}
export class GetChequeCotizacionAction {
  static readonly type = "[Cheque] GetChequeCotizacionAction";
  constructor(public payload: { id: any }) {}
}

export class ComprarChequeAction {
  static readonly type = '[Cheque] ComprarChequeAction';
  constructor(public payload:{chequeId:number}) {}
}

export class OfertarPorChequeAction {
  static readonly type = '[Cheque] OfertarPorChequeAction';
  constructor(public payload:{chequeId:number, importeEsperado:number, horasVencimiento:number, horasAcreditacion:number }) {}
}

export class CambiarMontoEsperadoChequeAction {
  static readonly type = '[Cheque] CambiarMontoEsperadoChequeAction';
  constructor(public payload:{chequeId:number, nuevoEsperado:number}) {}
}
export class CambiarAceptaOfertaChequeAction {
  static readonly type = '[Cheque] CambiarAceptaOfertaChequeAction';
  constructor(public payload:{chequeId:number, aceptaOferta:boolean}) {}
}

export class EliminarChequeAction {
  static readonly type = '[Cheque] EliminarChequeAction';
  constructor(public payload:{chequeId:number}) {}
}
